import apiClient from './client';
import type {
  AdminUserListItem,
  CreateUserRequest,
  FeatureCatalogItem,
} from '../types/admin';

// Feature 011 — Admin surface client. Every method requires the caller to be
// authenticated as Admin.
export const adminApi = {
  listUsers: async (): Promise<AdminUserListItem[]> => {
    const response = await apiClient.get<AdminUserListItem[]>('/admin/users');
    return response.data;
  },

  createUser: async (request: CreateUserRequest): Promise<AdminUserListItem> => {
    const response = await apiClient.post<AdminUserListItem>('/admin/users', request);
    return response.data;
  },

  changeRole: async (userId: number, role: 'Editor' | 'Public User'): Promise<AdminUserListItem> => {
    const response = await apiClient.patch<AdminUserListItem>(
      `/admin/users/${userId}/role`,
      { role }
    );
    return response.data;
  },

  grantFeature: async (userId: number, featureCode: string): Promise<void> => {
    await apiClient.post(`/admin/users/${userId}/features/${featureCode}`);
  },

  revokeFeature: async (userId: number, featureCode: string): Promise<void> => {
    await apiClient.delete(`/admin/users/${userId}/features/${featureCode}`);
  },

  getCatalog: async (): Promise<FeatureCatalogItem[]> => {
    const response = await apiClient.get<FeatureCatalogItem[]>('/admin/features');
    return response.data;
  },
};
